import { EventStatus } from "@/sharedTypes";
import { baseApi } from "../baseApi";

const eventStatusTag = "EventStatus";

export const eventStatusApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getEventStatuses: builder.query<any, Record<string, any> | void>({
      query: (params) => {
        const searchParams = new URLSearchParams();

        if (params) {
          const { filters, pagination } = params as any;

          if (filters) {
            Object.entries(filters).forEach(([key, value]) => {
              if (value !== undefined && value !== null && value !== "") {
                searchParams.append(key, String(value));
              }
            });
          }

          if (pagination) {
            Object.entries(pagination).forEach(([key, value]) => {
              if (value !== undefined && value !== null) {
                searchParams.append(key, String(value));
              }
            });
          }
        }

        const queryString = searchParams.toString();
        return `/gw/event-statuses${queryString ? `?${queryString}` : ""}`;
      },
      providesTags: [eventStatusTag],
    }),
    createEventStatus: builder.mutation({
      query: (payload: EventStatus) => ({
        url: "/gw/event-statuses",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [eventStatusTag],
    }),
    updateEventStatus: builder.mutation({
      query: ({ id, ...payload }: EventStatus) => ({
        url: `/gw/event-statuses/${id}`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: [eventStatusTag],
    }),
    deleteEventStatus: builder.mutation({
      query: (id: number) => ({
        url: `/gw/event-statuses/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [eventStatusTag],
    }),
  }),
});

export const {
  useGetEventStatusesQuery,
  useCreateEventStatusMutation,
  useUpdateEventStatusMutation,
  useDeleteEventStatusMutation,
} = eventStatusApi;
